export default {
	title: 'Definición de Onda',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar por Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar {count} registro(s) seleccionado(s)?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione el registro a eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		label: 'Etiqueta',
		value: 'Código de Valor',
		placeholder: {
			label: 'Ingrese la etiqueta',
			value: 'Ingrese el código de valor'
		}
	},
	table: {
		id: 'ID',
		label: 'Etiqueta',
		value: 'Código de Valor',
		unit: 'Unidad',
		sort: 'Ordenar'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		label: 'Etiqueta',
		value: 'Código de Valor',
		unit: 'Unidad',
		sort: 'Ordenar',
		remark: 'Observación',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			label: 'Ingrese la etiqueta',
			value: 'Ingrese el código de valor',
			unit: 'Ingrese la unidad',
			remark: 'Ingrese la observación'
		}
	}
}
